import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const FacturacionEstatusService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Facturacion_Estatus_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			facturacion_estatus: form.facturacion_estatus,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Facturacion_Estatus_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_facturacion_estatus: form.id_cat_facturacion_estatus,
			facturacion_estatus: form.facturacion_estatus,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Facturacion_Estatus_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_facturacion_estatus) => {
		let params = {
			id_cat_facturacion_estatus: id_cat_facturacion_estatus
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Facturacion_Estatus_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
